const pixelsCategories = ["SOCIAL","TARGETING","STRICTLY_NECESSARY"];

export { pixelsCategories };